import { Component } from '@angular/core';
import { AlertController, App } from 'ionic-angular';
import { WalletPage } from '../wallet/wallet';
import { MypagePage } from '../mypage/mypage';
// import { WithdrawalcoinlistPage } from '../withdrawalcoinlist/withdrawalcoinlist';
import { ApplylistPage } from '../applylist/applylist';
import { WithdrawalPage } from '../withdrawal/withdrawal';
// import { TransferPage } from '../transfer/transfer';
// import { P2pPage } from '../p2p/p2p';
// import { MygroupPage } from '../mygroup/mygroup';
// import { LogoutModalPage } from '../logout-modal/logout-modal';

@Component({
  	templateUrl: 'tabs.html'
})
export class TabsPage {

	tab1Root = WalletPage;  
	tab2Root = ApplylistPage;
	// tab3Root = P2pPage;
	tab3Root = WithdrawalPage;
	tab4Root = MypagePage;

	texts: any = [];
    language: string;

	constructor(		
		public alertCtrl: AlertController,
		public app: App
	) {
		
	}

	ionViewWillEnter() {	
		this.language = localStorage.getItem("language");

		this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).tabs;
	}

	_back() {
		let alert = this.alertCtrl.create({
			message: this.texts.alertM_ready,
			buttons: ['OK']
		});
		alert.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts